import { UsuarioService } from './usuario.service';
import { ProdutoService } from './produto.service';
import { EquipamentoService } from './equipamento.service';
import { CondicaoPagamentoService } from './condicao-pagamento.service';
import { CarrinhoPedidoService } from './carrinho-pedido.service';
import { PedidoService } from './pedido.service';
import { DadosService } from './dados.service';
import { MensagemService } from './mensagem.service';
import { BancoService } from './banco.service';
export {UsuarioService, ProdutoService, EquipamentoService, 
        CondicaoPagamentoService, CarrinhoPedidoService,
        PedidoService, DadosService, MensagemService,
        BancoService};


// WEBPACK FOOTER //
// ./src/app/services/service.ts